import { useChatStore } from '@/store/chatStore';

export default function SessionSidebar() {
  const {
    sessions,
    currentSessionId,
    switchSession,
    deleteSession,
    createSession,
  } = useChatStore();

  const sessionIds = Object.keys(sessions);
  const hasSessions = sessionIds.length > 0;

  return (
    <div className="session-sidebar">
      <div className="sidebar-header">
        <h3>Sessions</h3>
        <button
          onClick={() => createSession(`session-${Date.now()}`)}
          className="create-session-button"
          aria-label="New Session"
        >
          + New Session
        </button>
      </div>

      {!hasSessions && (
        <div className="empty-state">
          <p>No sessions yet</p>
        </div>
      )}

      <div className="sessions-list">
        {sessionIds.map((sessionId) => {
          const session = sessions[sessionId];
          const isActive = sessionId === currentSessionId;

          return (
            <div
              key={sessionId}
              className={`session-item ${isActive ? 'active' : ''}`}
              onClick={() => switchSession(sessionId)}
            >
              <span className="session-name">{session.name}</span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  deleteSession(sessionId);
                }}
                className="delete-button"
                aria-label={`Delete ${session.name}`}
              >
                Delete
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
